import { css, Global } from "@emotion/react";
import theme from "@theme";

// Define the styles using css from Emotion
const inputStyles = css`
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Hide arrows in Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
    

  .swal-button {
    background: ${theme.gradient.themeGradient} !important;
    color: white !important;
  }

  .swal-button--cancel {
     color: #555!important; 
     background: #efefef!important; 
}

  body {
    font-family: Roboto, sans-serif !important;
  }
  /* Modern Switch/Toggle Styling */
  .MuiSwitch-root {
    width: 52px !important;
    height: 28px !important;
    padding: 0 !important;
  }
  
  .MuiSwitch-switchBase {
    padding: 2px !important;
    transition: all 0.3s ease !important;
  }
  
  .MuiSwitch-switchBase.Mui-checked {
    color: white !important;
    transform: translateX(24px) !important;
  }
  
  .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    background: linear-gradient(135deg, #E36E00 0%, #FFAE00 100%) !important;
    opacity: 1 !important;
    border-radius: 14px !important;
    transition: all 0.3s ease !important;
  }
  
  .MuiSwitch-track {
    background: rgba(156, 163, 175, 0.3) !important;
    border-radius: 14px !important;
    opacity: 1 !important;
    transition: all 0.3s ease !important;
  }
  
  .MuiSwitch-thumb {
    width: 20px !important;
    height: 20px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
    transition: all 0.3s ease !important;
  }
  
  .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb {
    box-shadow: 0 2px 8px rgba(227, 110, 0, 0.3) !important;
  }
  
  .MuiSwitch-switchBase:hover {
    background: rgba(227, 110, 0, 0.08) !important;
  }
  
  .MuiSwitch-switchBase.Mui-checked:hover {
    background: rgba(227, 110, 0, 0.12) !important;
  }
  
  /* When switch is disabled */
  .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track {
    background: rgba(156, 163, 175, 0.2) !important;
    opacity: 0.5 !important;
  }
  
  .MuiSwitch-switchBase.Mui-disabled {
    color: rgba(156, 163, 175, 0.5) !important;
  }
  
  .MuiSwitch-switchBase.Mui-disabled .MuiSwitch-thumb {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  }
    
  .ant-picker:hover,
  .ant-picker-focused {
    border-color: ${theme.colors.themeColor} !important;
  }



  .ant-picker-cell-selected .ant-picker-cell-inner {
    background-color: ${theme.colors.themeColor} !important;
    color: white !important;
  }

  .ant-picker-cell:hover .ant-picker-cell-inner {
    background-color: ${theme.colors.themeColor} !important;
    color: white !important;
  }

  .ant-picker-today-btn,
  .ant-picker-now-btn,
  .ant-picker-ok {
    color: ${theme.colors.themeColor} !important;
  }

  .ant-picker-today .ant-picker-cell-inner {
    border-color: ${theme.colors.themeColor} !important;
  }

  .ant-picker-cell-today .ant-picker-cell-inner {
    border: 1px solid ${theme.colors.themeColor} !important;
    color: black !important; !important;
  }


   .ant-pagination-item-active,
  .ant-pagination-item:hover,
  .ant-pagination-prev:hover,
  .ant-pagination-next:hover {
    border-color: ${theme.colors.themeColor} !important;
  }

  .ant-pagination-item-active a,
  .ant-pagination-item:hover a {
    color: ${theme.colors.themeColor} !important;
  }

  .ant-pagination-item a {
    color: ${theme.colors.themeColor} !important;
  }
  
  .ant-dropdown .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${theme.colors.themeColor} !important; /* Change this to your preferred color */
    border-color: ${theme.colors.themeColor} !important;
  }
  /* OK button color */
  .ant-table-filter-dropdown-btns .ant-btn.ant-btn-primary {
    background-color: ${theme.colors.themeColor} !important; /* Override background */
    border-color: ${theme.colors.themeColor} !important; /* Override border */
    color: #FFFFFF !important; /* Optional: override text color */
  }
  /* Reset button color */
  .ant-table-filter-dropdown-btns .ant-btn:not(.ant-btn-primary) {
    color: ${theme.colors.themeColor} !important; /* Override text color */
    border-color: ${theme.colors.themeColor} !important; /* Override border */
  }
  /* Active filter icon color */
  .ant-table-filter-column .anticon-filter {
    color: ${theme.colors.themeColor} !important; /* Change this to your preferred active color */
  }
  /* Active ascending sort icon color */
  .ant-table-column-sorter-up.active {
    color: ${theme.colors.themeColor} !important; /* Change this to your preferred color */
  }
  /* Active descending sort icon color */
  .ant-table-column-sorter-down.active {
    color: ${theme.colors.themeColor} !important; /* Change this to your preferred color */
  }

  
 input:hover, 
input:focus, 
input:active {
  border-color: ${theme.colors.themeColor} !important; 
}
  
 textarea:hover, 
textarea:focus, 
textarea:active {
  border-color: ${theme.colors.themeColor} !important; 
}
  

/* Apply cursor pointer only to dropdown items */
.ant-select-item {
  cursor: pointer !important; 
}



 input:hover, 
input:focus, 
input:active {
  border-color: ${theme.colors.themeColor} !important; 
}


input[type="checkbox"]:hover,
input[type="checkbox"]:focus,
input[type="checkbox"]:active {
  color: ${theme.colors.themeColor} !important;
   background-color: ${theme.colors.themeColor} !important;
}

input[type="checkbox"]:checked {
  color: ${theme.colors.themeColor} !important; 
   background-color: ${theme.colors.themeColor} !important;
}


 .ql-container.ql-snow {
    border: 1px solid #ccc;
    min-height: 100px !important;
    border-radius:0px 0px 5px 5px !important;

}

.ql-toolbar.ql-snow {
    border: 1px solid #ccc !important;
       border-radius:5px 5px 0px 0px !important;
}

  .ant-select-dropdown {
    z-index: 9999 !important;
    padding: 0 !important;
  }

  /* Change the hover border color */
.ant-select:hover .ant-select-selector {
  border-color:${theme.colors.themeColor} !important; 
}
  .ant-select-focused .ant-select-selector {
  border-color:${theme.colors.themeColor} !important;  /* Replace with your desired focus border color */
}

/* Change the selected color */
.ant-select-item-option-selected {
  background-color:${theme.colors.themeColor} !important;  /* Replace with your desired selected background color */
  color: #ffff !important; /* Adjust text color if needed */
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: ${theme.colors.themeColor} !important;
  border-color: ${theme.colors.themeColor} !important;
}

.ant-checkbox-checked::after {
  border-color: ${theme.colors.themeColor} !important;
}

:where(.css-dev-only-do-not-override-17seli4) .ant-tree .ant-tree-checkbox-checked .ant-tree-checkbox-inner {
      background-color: ${theme.colors.themeColor}!important;
        border-color: ${theme.colors.themeColor}!important;
}


.ant-checkbox-disabled+span {
    color: black !important;
    opacity: 0.8 !important;
}
    
.ant-select-selection-placeholder {
  opacity: 0.6!important;
}


.ql-editor img {
  max-width: 600px !important;
  max-height: 300px !important;
}

.ql-editor {
  word-wrap: break-word; 
  white-space: pre-wrap; 
  overflow-wrap: break-word; 
  word-break: break-word;
  max-width: 100%; 
    overflow-y: auto;
    line-height: 2;
}
.ql-container {
  max-height: 550px !important;
  display: flex;
  flex-direction: column;
}


.MuiFormControlLabel-root {
  margin: 0px -10px 0px -3px !important;
  }


  input[type="radio"]:checked + .custom-radio {
  background-color: orange !important;
  border-color: orange!important;
}

.custom-radio::after {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: white;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: all 0.3s ease;
}

input[type="radio"]:checked + .custom-radio::after {
  background-color: white;
}

// .swal-overlay--show-modal .swal-modal{
//   background-color: #808080 !important;
//   }

  // .swal-title{
  // color: white !important;
  // }

  // .swal-text{
  // color: white !important;
  // }


  .swal-icon--success__ring{
  border: 3px solid #A5DC86 !important;
  }

   .ant-modal-mask {
    background-color: black !important; 
  }

  .custom-datepicker input::placeholder {
  color: #888!important;         
  font-size: 14px!important;       
}





 
`;

// Export a component that applies the Global styles
const GlobalStyles = () => <Global styles={inputStyles} />;

export { GlobalStyles };
